import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestAuth } from "application/auth/authActions";
import { LocalStorageDisabled } from "components/common/LocalStorageDisabled/LocalStorageDisabled";
import { checkLocalStorage } from "helpers/localStorageHelper";
import { isFinished, isLoading } from "helpers/requestStateHelper";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

export const AuthBoundary = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const config = useSelector(state => state.config);
  const location = useLocation();
  const history = useHistory();
  const isLocalStorageEnabled = useMemo(checkLocalStorage, []);

  useEffect(() => {
    if (!isFinished(config)) throw new Error("Config should be loaded before authentication");

    if (!isLocalStorageEnabled) {
      return;
    }

    dispatch(requestAuth());
  }, []);

  // syncing React Router location with window.location after authentication library redirects
  useEffect(() => {
    const windowRoute = window.location.pathname + window.location.search;
    const reactRoute = location.pathname + location.search;

    if (reactRoute !== windowRoute) {
      history.replace(windowRoute);
    }
  });

  if (!isLocalStorageEnabled) {
    return <LocalStorageDisabled />;
  }

  if (isLoading(auth)) {
    return <Loader />;
  }
  return <>{children}</>;
};
